module.exports = __webpack_public_path__ + "img/FR17515.c39a1272.png";